import Container from "@mui/material/Container";
import { FC } from "react";

import { useAppSelector } from "store";
import { selectPageSelectedJob } from "store/root.store";
import { ReadOnlyMeterReading } from "./ReadOnlyMeterReading";

export const ReadOnlyMeterTab: FC = () => {
  const { meters: jobMeters } = useAppSelector(selectPageSelectedJob);
  const meters = jobMeters?.slice() || [];

  return (
    <Container data-testid="MeterTab">
      {meters.map((meter) => (
        <div key={meter?.name}>
          <ReadOnlyMeterReading meter={meter} />
        </div>
      ))}
    </Container>
  );
};
